import * as React from "react";
import {cx} from "emotion";

import "./list-mode.scss";

import {cs}                     from "@Common/react/chain-services";
import {keyed}                  from "@Common/react/keyed";
import {UseState}               from "@Common/react/use-state";
import {isIe, isEdge}           from "@Common/ui-components/debug/is-ie-edge-or-firefox";
import {formatMoneyBackOptions} from "@Common/ui-components/language/format-money";
import {Responsive}             from "@Common/ui-components/responsive";

import {Tooltip}         from "../../../../../../../../common/tool-tip";
import {filteredOptions} from "../../../../../../../common/filtered-options";

export const ListMode = ({templateBacks, onZoom, onButton, onImage, selected}) => cs(
    ["hovered", (_, next) => UseState({
        initValue: null,
        next,
    })],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ({hovered, responsive}) => ( 
        <div className={cx("mode-list mode-list-2ux", {"ie": isIe(), "edge": isEdge()})}>
            {templateBacks.map((back, i) => cs(
                keyed(i),
                () => (
                    <div
                        className={cx("template-back")}
                        xd-qa-type="template_back"
                    >
                        <Tooltip/>
                        <div 
                            className={cx("box", {hovered: hovered.value === back})}
                            onMouseEnter={() => hovered.onChange(back)}
                            onMouseLeave={() => hovered.onChange(null)}
                        >

                            <img 
                                src={back.image}
                                onClick={(e) => {
                                    // e.preventDefault();
                                    e.stopPropagation();
                                    onImage(back.id);
                                }}
                                xd-qa-type="icon"
                                xd-qa-name={back.name}
                            />

                            {selected.value === back.id && (
                                <div className="check">
                                    <i className="fa fa-check"/>
                                </div>
                            )}
                            {responsive.ge("mobile") && (
                                <button
                                    onClick={(e) => {
                                        // e.preventDefault();
                                        e.stopPropagation();
                                        onButton(back.id);
                                    }}
                                    xd-qa-type="button"
                                    xd-qa-name="SELECT THIS TEMPLATE"
                                >
                                    SELECT THIS TEMPLATE
                                </button>
                            )}
                        </div>
                        <div 
                            className="footer"
                        >
                            <div className="text">
                                <div className="back-name" data-tip={back.name}>
                                    {back.name}
                                </div>
                                {back.option && back.option.length > 0 && (
                                    <div 
                                        className="upgrade-option" 
                                        data-tip={
                                            `${"" + (formatMoneyBackOptions(back.option.reduce((cnt, option) => {return cnt + option.unitprice;}, 0)))} - ${filteredOptions(back.option)}`
                                        }
                                    >
                                        {formatMoneyBackOptions(back.option.reduce((cnt, option) => {return cnt + option.unitprice;}, 0))}
                                        {" "}
                                        {" - "}
                                        {filteredOptions(back.option)}
                                    </div>
                                )}
                            </div>
                            {responsive.ge("mobile") && (
                                <div
                                    className="zoom"
                                    onClick={(e) => {
                                        // e.preventDefault();
                                        e.stopPropagation();
                                        onZoom(back.id);
                                    }}
                                    xd-qa-type="icon"
                                    xd-qa-name="zoom"
                                >
                                    <i className="fa fa-search"/>
                                </div>
                            )}
                        </div>
                    </div>
                )
            ))}
        </div>
    )
);
